export const CONTACTS = {
  email: 'dmowski.alex@gmail.com',
  instagram: 'https://www.instagram.com/dmowskii/',
  github: 'https://github.com/dmowski/fluencypal',
};
